<div class="media profile-media">
  <img class="b-r-10 profileImg" [src]="profileImg" alt="">
  <div class="media-body"><span>{{firstName}}</span>
     <p class="mb-0 font-roboto">{{lastName}} <i class="middle fa fa-angle-down"></i></p>
  </div>
</div>
<ul class="profile-dropdown onhover-show-div" style="width: 275px; left: -100px;">
  <li *ngFor="let menu of common.IWantToMenu">
    <a (click)="open(menu.navigateURL)">
      <app-feather-icons [icon]="menu.iconCSS"></app-feather-icons>
      <span>{{menu.moduleName}} </span>
    </a>
  </li>
  <!--<li><a href="email"><app-feather-icons [icon]="'mail'"></app-feather-icons><span>Inbox</span></a></li>
  <li><a href="/to-do"><app-feather-icons [icon]="'file-text'"></app-feather-icons><span>Taskboard</span></a></li>
  <li><a href="/faq"><app-feather-icons [icon]="'settings'"></app-feather-icons><span>Settings</span></a></li>-->
  <li (click)="logoutFunc()"><app-feather-icons [icon]="'log-in'"></app-feather-icons><span>Log out</span></li>
</ul>